module.exports = __webpack_public_path__ + "img/BA.9667c137.png";